import {BaseViewModel} from "../../../../../infrastructure/models/base-view-model";

export class ChartEventDetailsModel extends BaseViewModel {
  constructor(model: ChartEventDetailsModel) {
    super();

    this.key = model.key;
    this.aliasName = model.aliasName;
    this.value = model.value;
  }
}
